<div class="flex min-h-screen w-full">
  <!-- Left: Image -->
  <div
    class="hidden md:block w-1/2 bg-cover bg-center"
    style="background-image: url('assets/images/slider/slider_2.webp');">
  </div>

  <!-- Right: Form -->
  <div class="w-full md:w-1/2 flex items-center justify-center p-6 bg-white">
    <div class="w-full max-w-xl">
      <!-- University Logo -->
      <div class="flex justify-center mb-4">
        <img src="assets/images/logo/arni-updated-logo.png" alt="ARNI University Logo" class="h-12 md:h-16" />
      </div>

      <div class="mb-4 text-center md:text-left">
        <h2 class="text-2xl md:text-3xl font-bold text-gray-800 mb-1" *ngIf="formType === 'signIn'">
          ARNI University - Scholarship Exam
        </h2>
        <p class="text-gray-600 text-base md:text-lg" *ngIf="formType === 'signIn'">
          Register Now.
        </p>
      </div>

      <form [formGroup]="signInForm" class="space-y-2" *ngIf="formType === 'signIn'">
        <!-- Name -->
        <mat-form-field class="w-full mb-1" appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput placeholder="Enter name" formControlName="name" />
          <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('name').hasError('required')">
            Name is required
          </small>
        </mat-form-field>

        <!-- Program -->
        <mat-form-field class="w-full mb-1" appearance="outline">
          <mat-label>Program</mat-label>
          <mat-select formControlName="program" (selectionChange)="getCourse()">
            <mat-option *ngFor="let program of programs" [value]="program?.program?.id">
              {{ program?.program?.name }}
            </mat-option>
          </mat-select>
          <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('program').hasError('required')">
            Program is required
          </small>
        </mat-form-field>

        <!-- Course -->
        <mat-form-field class="w-full mb-1" appearance="outline">
          <mat-label>Course</mat-label>
          <mat-select formControlName="course" (selectionChange)="getBranch()">
            <mat-option *ngFor="let course of courses" [value]="course?.course?.id">
              {{ course?.course?.name }}
            </mat-option>
          </mat-select>
          <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('course').hasError('required')">
            Course is required
          </small>
        </mat-form-field>

        <!-- Branch -->
        <mat-form-field *ngIf="showBranchField" class="w-full mb-1" appearance="outline">
          <mat-label>Branch</mat-label>
          <mat-select formControlName="branch" (selectionChange)="getMappingId()">
            <mat-option *ngFor="let branch of branches" [value]="branch?.branch?.id">
              {{ branch?.branch?.name }}
            </mat-option>
          </mat-select>
          <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('branch').hasError('required')">
            Branch is required
          </small>
        </mat-form-field>

        <!-- Email -->
        <mat-form-field class="w-full mb-1" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Enter Email" formControlName="email" />
          <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('email').hasError('required')">
            Email is required
          </small>
        </mat-form-field>

        <!-- Contact + OTP -->
        <div class="flex gap-2">
          <mat-form-field class="flex-1 mb-1" appearance="outline">
            <mat-label>Contact</mat-label>
            <input matInput formControlName="contact" placeholder="Enter Contact Number"
                   [readonly]="is_submitting" [disabled]="is_submitting" />
            <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('contact').hasError('required')">
              Contact is required
            </small>
          </mat-form-field>
          <button (click)="getOtp()" mat-raised-button class="bg-blue-500 text-white mt-2" [disabled]="is_submitting">
            Verify
          </button>
        </div>

        <!-- OTP -->
        <mat-form-field *ngIf="showOtpField" class="w-full mb-1" appearance="outline">
          <mat-label>OTP</mat-label>
          <input matInput placeholder="Enter OTP" formControlName="otp" />
          <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('otp').hasError('required')">
            OTP is required
          </small>
        </mat-form-field>

        <!-- Aadhaar -->
        <mat-form-field class="w-full mb-1" appearance="outline">
          <mat-label>Aadhar Number</mat-label>
          <input matInput placeholder="Enter Aadhar Number" formControlName="aadhaar_number" />
          <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('aadhaar_number').hasError('required')">
            Aadhar Number is required
          </small>
        </mat-form-field>
        <p class="text-sm text-gray-600" style="margin-top: -10px; margin-bottom: 15px">
          ⚠️ <strong>Note:</strong> Aadhar number will be used for verification. Please ensure accuracy.
        </p>

        <!-- DOB -->
        <mat-form-field class="w-full mb-2" appearance="outline">
          <mat-label>Date of Birth</mat-label>
          <input matInput placeholder="yyyy-mm-dd" formControlName="dob" type="date" />
          <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('dob').hasError('required')">
            Date of Birth is required
          </small>
        </mat-form-field>

        <button (click)="signIn()" mat-raised-button class="w-full bg-blue-600 text-white py-2 rounded">
          REGISTER
        </button>

        <p class="text-center text-gray-600 mt-3 text-sm">Already have an account? <br />
          <a class="text-blue-500 cursor-pointer hover:underline" (click)="goTo('auth/login')">Login here</a>
        </p>
      </form>
    </div>
  </div>
</div>
